import { render } from "./CountdownCirclePage.vue?vue&type=template&id=b8ce5a54"
import script from "./CountdownCirclePage.vue?vue&type=script&lang=js"
export * from "./CountdownCirclePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__